import { render } from "./OplusChatIcon.vue?vue&type=template&id=5b5d5a9e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__